function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
} 

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.product-form__input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
       selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
} 
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    // 03-08-23 variant picker on load preselector
     window.addEventListener('load', () => {
      this.onVariantChange(); // Call onVariantChange on page load
    });
  }

  onVariantChange() {
   
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() { 
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

// updated this to correct image position in slider on variant change 07/10/2023
  
  updateMedia() {
  
      console.log("Current Variant (updateMedia): ", this.currentVariant);
        if (!this.currentVariant) return;
        var tpp = this.currentVariant.price;
        $('.pro_price').text(Shopify.formatMoney(tpp,'${{amount}}'));
        if (!this.currentVariant.featured_media) return;
        const newMedia = document.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );
      
        // to set the product image as first on variant change
        var newImg = this.currentVariant.featured_image;

         // Query the select boxes
    const colorSelectBox = document.querySelector('.variantSelect_1'); // Replace with the actual selector
    const sizeSelectBox = document.querySelector('.variantSelect_2'); // Replace with the actual selector

// Code for single selectbox showing first variant image in slider
    
    // Function to handle the change event
      let handleChange = (event) => {
        // Additional logic for updating the image can go here
      
        if (colorSelectBox && !sizeSelectBox) {
          // Only color select box is present
          if (newImg.position !== 1) {
            newImg.position = 1;
          }
      
          // Remove the event listener after the first change
          colorSelectBox.removeEventListener('change', handleChange);
        }
      };
      
      // Add event listener for the first change
      if (colorSelectBox && !sizeSelectBox) {
        colorSelectBox.addEventListener('change', handleChange);
      
        // Create a new event and dispatch it on load
        const event = new Event('change');
        colorSelectBox.dispatchEvent(event);
      }
    
        $('.product-single__image_slideshow:not(.not_fixed_first_img)').slick( "goTo", 0);
        $('.product-single__image_slideshow.not_fixed_first_img').slick( "goTo", newImg.position - 1);
        console.log(this.currentVariant);

// Code for alphabet product to show correct images
        
        // Code for alphabet product to show correct images
    
       // Function to handle the change event for variant selects(selectbox)
        // function handleVariantChange() {
        //     // Get the selected values of both .variantSelect_1 and .variantSelect_2
        //     var selectedValue1 = $('.variantSelect_1').val();
        //     var selectedValue2 = $('.variantSelect_2').val();
        
        //     // Find the index of the selected option in .variantSelect_2
        //     var selectedIndex = $('.variantSelect_2').find('option[value="' + selectedValue2 + '"]').index() - 1;
        
        //     // Use Slick slider's slickGoTo method to navigate to the selected index
        //     $('.product-single__image_slideshow').slick('slickGoTo', selectedIndex);
        // }
        
        // // Merge event listeners for variantSelect_1 and variantSelect_2
        // $('#pave-alphabet-pendant-single .variantSelect_1, #pave-alphabet-pendant-single .variantSelect_2, #4mm-infinity-hoops-pair .variantSelect_1, #4mm-infinity-hoops-pair .variantSelect_2, #4mm-infinity-hoop-single .variantSelect_1, #4mm-infinity-hoop-single .variantSelect_2').change(function() {
        //     // Call the common function to handle the change event
        //     handleVariantChange();
        // });

        // Function to handle the change event for variant radios(radios)
        function handleVariantChange() {
            // Get the selected values of both radio button groups
            var selectedValue1 = $('.variantRadio_1 input:radio:checked').val();
            var selectedValue2 = $('.variantRadio_2 input:radio:checked').val();

            // Check if both values are selected
            if (!selectedValue1 || !selectedValue2) {
                console.error('One or more radio button groups have no selected value');
                return; // Exit the function early if any value is missing
            }
          
            // Find the index of the selected option in .variantRadio_2
            var selectedIndex = $('.variantRadio_2 input:radio[value="' + selectedValue2 + '"]').index(); 
            // Check if the index is even
            if (selectedIndex % 2 === 0) {
              // If it's even, divide by 2
              selectedIndex = selectedIndex / 2;
            }
          
            // Check if selectedIndex is valid
            if (selectedIndex === -1) {
                console.error('Selected index is invalid');
                return; // Exit early if no valid index is found
            }
          
            // Use Slick slider's slickGoTo method to navigate to the selected index
            $('.product-single__image_slideshow').slick('slickGoTo', selectedIndex);
        }
        
        // Merge event listeners for variantRadio_1 and variantRadio_2
        $('#pave-alphabet-pendant-single .variantRadio_1 input:radio, #pave-alphabet-pendant-single .variantRadio_2 input:radio, #4mm-infinity-hoops-pair .variantRadio_1 input:radio, #4mm-infinity-hoops-pair .variantRadio_2 input:radio, #4mm-infinity-hoop-single .variantRadio_1 input:radio, #4mm-infinity-hoop-single .variantRadio_2 input:radio').change(function() {
            // Call the common function to handle the change event
            // console.log('Radio button changed');
            handleVariantChange();
        });

        console.log(newImg);
        if (!newMedia) return;
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        const parent = newMedia.parentElement;
        if (parent.firstChild == newMedia) return;
        modalContent.prepend(newMediaModal);
        parent.prepend(newMedia);
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if(this.stickyHeader) {
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
        
        window.setTimeout(() => {
        parent.scrollLeft = 0;
        parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
        });
}


  updateURL() {
    console.log(this.currentVariant);
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
    updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
    
           $('.overlap_div').hide();
           $('.overlay_cursor').show();
      
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      
        $('.overlay_cursor').hide();
        $('.overlap_div').show();
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

  

$(document).ready(function () {    
    
  
      $('.home_prod_slider-list').slick({
  	    arrows: true,
        dots: false,
        swipeToSlide: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1023,
            settings: {
              arrows: true,
              slidesToShow:3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              centerMode:true,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false
            }
          }
        ]
  });
});



$(document).ready(function () {    
      $('.home_prod_sliderr').slick({
  	    arrows: true,
        dots: false,
        swipeToSlide: true,
        slidesToShow: 6,
  		infinite: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right hh"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1023,
            settings: {
              arrows: true,
              slidesToShow:3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              centerMode:false,
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
  			  infinite: true,
            }
          }
        ]
  }); 
  
  
  
  

  $('.page_prod_sliderr').slick({
  	    arrows: true,
        dots: false,
        swipeToSlide: true,
        slidesToShow: 4,
  		infinite: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1023,
            settings: {
              arrows: true,
              slidesToShow:3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              centerMode:false,
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false
            }
          }
        ]
  });




$('.primavera_page_prod_sliderr').slick({
  	    arrows: true,
        dots: false,
        swipeToSlide: true,
        slidesToShow: 5,
  		infinite: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1023,
            settings: {
              arrows: true,
              slidesToShow:3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              centerMode:false,
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false
            }
          }
        ]
  });


  
  

  $('.page_prod_sliderrr').slick({
  	    arrows: true,
        dots: false,
        swipeToSlide: true,
        slidesToShow: 7,
  		infinite: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1023,
            settings: {
              arrows: true,
              slidesToShow:3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              centerMode:false,
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false
            }
          }
        ]
  });
  
});

/*
$(document).ready(function () {    
      $('.home_prod_sliderr').slick({
  	    arrows: true,
        dots: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1023,
            settings: {
              arrows: true,
              slidesToShow:3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              infinite: false,
              centerMode:false,
              slidesToShow:2,
              slidesToScroll: 1,
              dots: false
            }
          }
        ]
  });
});*/
 
 
$(document).ready(function() {
  $('.accordian-heading').click(function() {
    $('.accordian-heading').removeClass('active-heading');
    $('.accordian-description-inner').slideUp('normal');
    if($(this).next().is(':hidden') == true) {
      $(this).addClass('active-heading');
      $(this).next().slideDown('normal');
    } 
  });
  $('.accordian-description-inner').hide();
  //$('.accordian_description .tab-description:first-child .accordian-description-inner').show();
  //$('.accordian_description .tab-description:first-child .accordian-heading').addClass('active-heading');

});
$(document).ready(function() {
  $('.template-product .prod_detailed_desc_wrap .sameheight h2').click(function() {
    $('.template-product .prod_detailed_desc_wrap .sameheight h2').removeClass('active-heading');
    $('.template-product .prod_detailed_desc_wrap .sameheight .desc_textbox').slideUp('normal');
    if($(this).next().is(':hidden') == true) {
      $(this).addClass('active-heading');
      $(this).next().slideDown('normal');
      $(this).parents('.sameheight').find('.desc_textbox').slideDown('normal');
    } 
  });
  $('.template-product .prod_detailed_desc_wrap .sameheight .desc_textbox').hide();
  //$('.template-product .prod_detailed_desc_wrap .sameheight:first-child .desc_textbox').show();
  //$('.accordian_description .tab-description:first-child .accordian-heading').addClass('active-heading');

});
$( document ).ready(function() {
$('.prod-row-carousel').slick({
        arrows: true,
        dots: false,
       swipeToSlide: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              arrows: true,
              slidesToShow: 6,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false
            }
          }
        ]
      });
  });


  $(document).ready(function(){
    $('.cart-overlay').click(function(e){
      $('body, .transformcontainer').toggleClass("iscartpopup"); 
      $("#engraving_yes").prop("checked", false); 
              $("#engraving_yes").attr('checked', false);
              $("#engraving_no").prop("checked", true);
              $("#engraving_no").attr('checked', true);
              var radioValue = 'No Engraving' ;
              $('#productSelect-option-0').val(radioValue).trigger('change');
    });
  });
   
$(document).ready(function(){
  var hdrhyt = $('#shopify-section-header').outerHeight();
 // alert(hdrhyt);
  var hdrpgpadd = hdrhyt ;
  var winhyt = $(window).height();
  var sectnhyt = winhyt - hdrhyt;
  $('.section_browserheight').css('height', sectnhyt);
  $('.section_browserminheight').css('min-height', sectnhyt);
  $('main.main-content').css('padding-top', hdrpgpadd);
  $('.template-index main.main-content').css('padding-top', hdrhyt);
    $('.site-nav.custommobmenus').css('min-height', sectnhyt);

  $(".absBottCenter").click(function() {
      $('html, body').animate({
          scrollTop: $(".collect_innerwrapper").offset().top
      }, 2000);
  });
  
  if ($(window).width() < 751) {
   $('.filters-sidebar').addClass("small--hide");
    $('.section_bg_color.section_custom_image_overlay').css('height', sectnhyt);    
  }
  else {
   $('.filters-sidebar').removeClass("small--hide");
  }
  
});


$( document ).ready(function(){
$('.search-bar__close, .desksearchbarr').click(function(e){
    e.preventDefault();
    $('.search-bar__interior').slideToggle();
    $('body').toggleClass("search_overlay"); 
    $('.head_title_pop').show();
    $('.popup-inner#ouibounce-modal').hide();
    $('body, .transformcontainer').removeClass("iscartpopup");
  });
  $('.search_overlay_div').click(function(e){
    $('body').toggleClass("search_overlay"); 
    $('.search-bar__interior').slideToggle();
    $('.popup-inner#ouibounce-modal').hide();
  });

$( document ).ready(function(){
  $( ".product-single__thumbnail" ).click(function( event ) {
  event.preventDefault();
});
});

$( document ).ready(function(){
$('.product-single__image_slideshow').slick({
        arrows: true,
        dots: true,
     	loop:false,
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
 		asNavFor: '.slider-nav-thumbnails',
     responsive: [
          {
            breakpoint: 50000,
            settings: {
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
        	  dotsClass: 'custom_paging',
              customPaging: function (slider, i) {
               //   console.log(slider);
                  return  (i + 1) + ' of ' + slider.slideCount;
              }
            }
          },
          {
            breakpoint: 832,
            settings: {
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              autoplay: false,
              dotsClass: 'custom_paging',
              customPaging: function (slider, i) {
                 // console.log(slider);
                   return  (i + 1) + ' of ' + slider.slideCount;
              }
            }
          }
        ]
 });
});
 $('.slider-nav-thumbnails').slick({
    slidesToShow: 3,
    infinite: true,
 	  slidesToScroll: 2,
    vertical: true,
 	asNavFor: '.product-single__image_slideshow',
 	dots: false,arrows: false,
 	 focusOnSelect: true,
    nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
    prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
    verticalSwiping: true,
    centerMode: true,
    focusOnSelect: true
 }); 
  
 // Remove active class from all thumbnail slides
 $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

 // Set active class to first thumbnail slides
 $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

 // On before slide change match active thumbnail to current slide
 $('.product-single__image_slideshow').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
      $('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
  });
});

function calculateProgress(currentVal, targetVal) {
    var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
    var successMsg = document.querySelectorAll('.cart-shipping__success');
    // calculate how far progress is from the total as a percentage
    var result = Math.round(100 * currentVal / targetVal);
    progressBar.forEach(function(el){
      el.setAttribute('style', "width: ".concat(result, "%"));
    })
  };


  $('#build-your-own-div ul.tabs a').click(function(){
    $('.chain_carousel .nextbtnn').trigger('click');
    $('.chain_carousel .prevbtnn').trigger('click');
  });

$( document ).ready(function(){
  $('#build-your-own-div ul.tabs').each(function(){
     var active, content, links = $(this).find('a');
     var $t  = $(this);
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
    
          $(this).find('a').click(function(e){
            links.not(':first').each(function () {
                // $($t.attr('href')).hide();
              });
            
           var hid = $(this).attr('href');
              $(hid).css('opacity','0');
            active.removeClass('active');
            $(this).parents().eq(2).find('.tab_p').hide();
            active = $(this);
            content = $($(this).attr('href'));
            active.addClass('active');
            content.show();
            setTimeout(function() {
              $(hid).css('opacity','1');
    		}, 1000);
    //         $('.chain_carousel').slick('unslick');
/*
          $('.chain_carousel').slick({
                  arrows: true,
                  dots: false,
                  //infinite: false,
                  swipeToSlide: true,
                  slidesToShow: 6,
                  slidesToScroll: 1,
                  adaptiveHeight: true,
                  nextArrow: '<div class="nextbtnn slick-arrow"><i class="fa fa-angle-right"></i></div>',
                  prevArrow: '<div class="prevvbtnn slick-arrow"><i class="fa fa-angle-left"></i></div>',
                  responsive: [
                    {
                      breakpoint: 1600,
                      settings: {
                        arrows: true,
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        dots: false
                      }
                    },
                    {
                      breakpoint: 1000,
                      settings: {
                        arrows: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: false
                      }
                    },
                    {
                      breakpoint: 750,
                      settings: {
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: false
                      }
                    }
                  ]
                });

//             $(hid +'.chain_carousel .nextbtnn').trigger('click');
//             $(hid +'.chain_carousel .prevbtnn').trigger('click');
*/
            return false;
          });
    });
});   

$(".click_down_btn").click(function() {
  var winHeight = $(window).height(),
    topOffset = $("#myDiv").offset().top + 80,
    elementHeight = $('#myDiv').height()
  var top = topOffset - winHeight + elementHeight;

  $('html, body').animate({
    scrollTop: top
  }, 1000);
});
    
$('.coll_btn_pop span').on('click', function(){
$('.coll_featured_block_top').addClass('pop_open');
});
$('.close_pop_coll').on('click', function(){
$('.coll_featured_block_top').removeClass('pop_open');
});

$(document).ready(function () {
      
$('.chain_carousel').slick({
              arrows: true,
              dots: false,
              //infinite: false,
              swipeToSlide: true,
              slidesToShow: 6,
              slidesToScroll: 1,
              adaptiveHeight: true,
              nextArrow: '<div class="nextbtnn slick-arrow"><i class="fa fa-angle-right"></i></div>',
              prevArrow: '<div class="prevvbtnn slick-arrow"><i class="fa fa-angle-left"></i></div>',
              responsive: [
                {
                  breakpoint: 1600,
                  settings: {
                    arrows: true,
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    dots: false
                  }
                },
                {
                  breakpoint: 1000,
                  settings: {
                    arrows: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: false
                  }
                },
                {
                  breakpoint: 750,
                  settings: {
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false
                  }
                }
              ]
});
  
$('.pro_chain_carousel').slick({
        arrows: true,
        dots: false,
    	infinite: false,
        swipeToSlide: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              arrows: true,
              slidesToShow: 6,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 5,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1000,
            settings: {
              arrows: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false
            }
          }
        ]
      });
});
  
/*
  $('.prod-row-carousel').slick({
        arrows: true,
        dots: false,
       swipeToSlide: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 3,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false
            }
          }
        ]
      });
    
    $('.blog_chain_carousel').slick({
        arrows: true,
        dots: false,
    	//infinite: false,
        swipeToSlide: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1000,
            settings: {
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false
            }
          }
        ]
      });
      
$('.tabs li').click(function(){
  $('.chain_carousel').slick();
});
    **/

 $(document).ready(function(){
    
    $('#CartContainer').on('click', '.btn.check', function (){
      //$('.custon_ship_pop,.ship_overlay ').hide();
      window.location.href ='/cart';
      //$('body, .transformcontainer').addClass("iscartpopup"); 
    });
 
});

$('.chain_carousel .product-single__cart-submit').click(function(){
var tid = $(this).data('id');
							e.preventDefault();
jQuery.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: 'quantity=1&id='+tid,
                        dataType: 'json',
                        success: function(e) { 
							e.preventDefault();

                        }
            });
});

$(function() {
    $('.cont_order_input').hide(); 
  $(".select_form_options").removeClass("slect_box");
    $('.select_form_options').change(function(){
        if($('.select_form_options').val() == 'Question about my order') {
          $(".select_form_options").addClass("slect_box");
            $('.cont_order_input').show(); 
        } else {
            $('.cont_order_input').hide(); 
          $(".select_form_options").removeClass("slect_box");
        } 
    });
});

//Engraver slider Js
 $('#close-personalize-properties').click(function(){
   	
     	 // $('body').toggleClass("iscartpopup");
   
      });

 $(document).ready(function () { 
$('.slider_mobile_down').slick({
  	arrows: true,
        dots: false,
       swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: '<div class="nextbtnn"><i class="fa fa-angle-right"></i></div>',
        prevArrow: '<div class="prevvbtnn"><i class="fa fa-angle-left"></i></div>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 1023,
            settings: {
              arrows: true,
              slidesToShow:1,
              slidesToScroll: 1,
              dots: false
            }
          },
          {
            breakpoint: 640,
            settings: {
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false
            }
          }
        ]
    });
  });

//menu-drop-down-accordion
  $('#parent_menus-1 .site-nav__child-link--parent').click(function(){
    //alert('running menu one');
      $('#drpdwn__menus-1').slideToggle('slow');   
  });
  
  $('#parent_menus-2 .site-nav__child-link--parent').click(function(){
    //alert('running menu two');
      $('#drpdwn__menus-2').slideToggle('slow');
  });

  // judge me app block class
 let checkInterval = setInterval(() => {
  let el = document.querySelector('.jdgm-carousel-wrapper');
  if (el) {
    el.parentElement.classList.add('has-carousel-jdgm');
    clearInterval(checkInterval); 
  }
}, 300);
setTimeout(()=>{
  document.querySelectorAll('.template-index .page-width').forEach((el, index) => {
  el.classList.add(`nqrt-div${index + 1}`);
});

}, 6000)

  function waitForElement(selector, interval = 100) {
  return new Promise(resolve => {
    const check = () => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
      } else {
        setTimeout(check, interval);
      }
    };
    check();
  });
}

async function addSpans() {
  const h2 = await waitForElement(".template-index #insta-feed h2");
  const span1 = document.createElement("span");
  const span2 = document.createElement("span");
  const span3 = document.createElement("span3");
  span3.innerHTML = "<a href='https://www.instagram.com/readymadejewelry/?hl=en'> readymadejewelry </a>";
  span1.classList.add('insta-span-tag')
  span2.classList.add('insta-icon-span-tag')
  span3.classList.add('insta-title-span-tag')
  span2.innerHTML = '<a href="https://www.instagram.com/readymadejewelry/?hl=en"> <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15" fill="none"> <rect width="15" height="15" fill="url(#pattern0_2803_2762)"/> <defs> <pattern id="pattern0_2803_2762" patternContentUnits="objectBoundingBox" width="1" height="1"> <use xlink:href="#image0_2803_2762" transform="scale(0.00348432)"/> </pattern> <image id="image0_2803_2762" width="287" height="287" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/> </defs> </svg> </a>'
  span1.prepend(span2);
  span1.appendChild(span3);
  h2.appendChild(span1);
}

// Run
addSpans();

setTimeout(()=>{
  const ul = document.querySelector(".menuudivs_2 ul");
  const iconsDiv = document.querySelector(".icons-dive1");
  const reference = ul.querySelector("li:nth-child(3)"); 
  if (reference) {
    ul.insertBefore(iconsDiv, reference.nextSibling); 
  } else {
    ul.appendChild(iconsDiv);
  }
}, 6000)
 
setTimeout(()=>{ 
  const favDiv = document.getElementById('redo-favorite-product-button-container-div');
  if (favDiv) favDiv.style.display = 'block' // NEB 2026-09-14: null-guard; Redo heart block disabled
const widget = document.getElementById('redo-product-widget');

if (favDiv && widget) {
  widget.appendChild(favDiv);
}
}, 4000)
// document.querySelector('.jdgm-carousel__item-wrapper').addEventListener('mouseenter', () => {
//     swiper.autoplay.stop();
// });
// setTimeout(()=>{ 
// const elements = document.querySelectorAll('.desktop_m_m');
// const header = document.querySelector('.header');

// if (header) {
//   const observer = new MutationObserver(mutations => {
//     mutations.forEach(mutation => {
//       if (mutation.attributeName === 'class') {
//         const el = mutation.target;
//         const isOpen = el.classList.contains('open');
//         //console.log(`${el.className} is open?`, isOpen);
//         header.style.position = isOpen ? 'relative' : window.scrollY == 0 ? 'absolute' : 'relative';
//       }
//     });
//   });

//   elements.forEach(el => {
//     observer.observe(el, { attributes: true, attributeFilter: ['class'] });
//   });
// } else {
//   console.warn('Header element not found');
// }
//   }, 3000);

  // search input 
//   setTimeout(()=>{
//   const searchInput = document.querySelector('.search__input');
//   const hideResult = document.querySelector('.mobile-custom-advanced-search .search-container')
//   const searchInputt = document.querySelector('.search-modal__content')
//   const preSearch = document.querySelector('#predictive-search-results');
//   if (searchInput) {
//     if (searchInput.value.trim() !== '') {
//       searchInput.classList.add('filled_input_now');
//       hideResult.style.display = "none";
//       preSearch.style.display = 'block';
//       searchInputt.style.justifyContent = 'flex-start';
//     }

//     searchInput.addEventListener('input', (event) => {
//       if (event.target.value.trim() !== '') {
//         searchInput.classList.add('filled_input_now'); 
//         hideResult.style.display = "none";
//          preSearch.style.display = 'block';
//         searchInputt.style.justifyContent = 'flex-start';
//       } else {
//         searchInput.classList.remove('filled_input_now'); 
//          hideResult.style.display = "block";
//          preSearch.style.display = 'none';
//          searchInputt.style.justifyContent = 'unset';
//       }
//     });
//   }
// }, 1500)
// setTimeout(() => {
//   const searchInput = document.querySelector('.search__input');
//   const hideResult = document.querySelector('.mobile-custom-advanced-search .search-container');
//   const searchModalContent = document.querySelector('.search-modal__content');
//   const showresult  = document.querySelector('.predictive-search')

//   // Check elements exist before continuing
//   if (!searchInput || !hideResult) {
//     console.warn('Some search elements not found');
//     return;
//   }

//   const updateUI = () => {
//     const isFilled = searchInput.value.trim() !== '';
//     if (isFilled) {
//       searchModalContent.style.justifyContent = 'flex-start';
//       hideResult.style.display = 'none';
//       showresult.style.display = 'block';
//     } else {
//       searchModalContent.style.justifyContent = 'unset';
//       hideResult.style.display = 'block';
//       showresult.style.display = 'none';
//     }
//   };

//   // Initial check in case it already has text
//   updateUI();

//   // Detect typing
//   searchInput.addEventListener('input', updateUI);

//   // Also detect when user is deleting using keyboard
//   searchInput.addEventListener('keydown', () => {
//     setTimeout(updateUI, 10);
//   });
// }, 1500);
setTimeout(() => {
  const searchInput = document.querySelector('.search__input');
  const hideResult = document.querySelector('.mobile-custom-advanced-search .search-container');
  const searchModalContent = document.querySelector('.search-modal__content');

  if (!searchInput || !hideResult || !searchModalContent) return;

  const updateUI = () => {
    const showresult = document.querySelector('#predictive-search-results');
    if (!showresult) return;

    const isFilled = searchInput.value.trim() !== '';
    if (isFilled) {
      searchModalContent.style.justifyContent = 'flex-start';
      hideResult.style.display = 'none';
      showresult.style.display = 'block';
    } else {
      searchModalContent.style.justifyContent = 'unset';
      hideResult.style.display = 'block';
      showresult.style.display = 'none';
    }
  };

  
  const observerTarget = searchModalContent;
  const observer = new MutationObserver(updateUI);
  observer.observe(observerTarget, { childList: true, subtree: true });
  searchInput.addEventListener('input', updateUI);
  searchInput.addEventListener('keydown', () => setTimeout(updateUI, 10));

  updateUI();
}, 1500);


//
document.addEventListener("DOMContentLoaded", () => {
  const toggles = document.querySelectorAll("#ToggleMobileMenu"); 
  const header = document.querySelector(".header");

  if (!header) {
    console.warn("Header not found!");
    return;
  }

  if (toggles.length) {
    toggles.forEach(toggle => {
      const observer = new MutationObserver(() => {
        const anyOpen = Array.from(toggles).some(t => t.classList.contains("open"));
        header.classList.toggle("header-white", anyOpen);
      });
      observer.observe(toggle, { attributes: true, attributeFilter: ["class"] });
    });
  }

  const updateHeader = () => {
    if (window.scrollY === 0) {
      header.classList.remove("scrolled");
    } else {
      header.classList.add("scrolled");
    }
  };
  window.addEventListener("scroll", updateHeader);
  updateHeader();
});

